import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../apiCalls/userApiCalls";

const afterSignInNavLinks = [
  {
    display: "Home",
    url: "/",
  },
  {
    display: "Study Packs",
    url: "/studypacksection",
  },
];

export default function StudyPackHeader() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const studyPackUser = JSON.parse(sessionStorage.getItem("studyPackUser"));
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {afterSignInNavLinks.map((item, index) => (
        <MenuItem key={index}>
          <Button
            variant="text"
            sx={{
              borderRadius: "20px",
            }}
            onClick={() => {
              navigate(`${item.url}`);
            }}
          >
            {item.display}
          </Button>
        </MenuItem>
      ))}
      <MenuItem>
        <Button
          variant="text"
          sx={{
            borderRadius: "20px",
          }}
          onClick={() => {
            logout();
            navigate("/");
          }}
        >
          Logout
        </Button>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        height="80px"
        sx={{
          background: " #fff",
          color: "#000",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <Box
            component="img"
            sx={{
              width: "120px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              marginTop: "8px",
              cursor: "pointer",
            }}
            src="https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2FS2A%20(1).png?alt=media&token=7361b0dc-d989-47fa-92a1-9ea0db08d3fc"
            alt="random"
            onClick={() => navigate("/")}
          ></Box>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Academy
          </Typography>
          <Box sx={{ flexGrow: 0.2 }} />
          <Typography
            sx={{
              fontWeight: 700,
              flexGrow: 1,
              color: "red",
              fontSize: {
                xs: "10px",
                sm: "10px",
                md: "14px",
                lg: "18px",
              },
            }}
          >
            {studyPackUser?.username
              ? `Welcome ${studyPackUser?.username}`
              : "You are not logged in"}
          </Typography>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <ul className="nav__list">
              {afterSignInNavLinks.map((item, index) => (
                <li key={index} className="nav__item">
                  <Button
                    variant="text"
                    sx={{
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      navigate(`${item.url}`);
                    }}
                  >
                    {item.display}
                  </Button>
                </li>
              ))}
              <li className="nav__item">
                <Button
                  variant="text"
                  sx={{
                    borderRadius: "20px",
                  }}
                  onClick={() => {
                    logout();
                    navigate("/");
                  }}
                >
                  Logout
                </Button>
              </li>
            </ul>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </Box>
  );
}
